import 'jquery';

const $window = $(window);
let targets = null;
function checkElementLocation()
{
  const bottom_of_window = $window.scrollTop() + $window.height();
  if (!targets) {
    targets = $('.content > .wp-block-media-text, .aaa-blog .preview, .aaa-events .preview');
  }
  targets.each(function () {
    const $that = $(this);
    const bottom_of_object = $that.position().top + 50; // + $that.outerHeight()
    //if element is in viewport, add the animate class
    if (bottom_of_window > bottom_of_object) {
      $that.addClass('fade-in');
    }
  });
}
checkElementLocation();

$(window).on('scroll', function () {
  checkElementLocation();
});
